module.exports = __webpack_public_path__ + "img/zywjicon.1c42ea4a.svg";